import * as $ from "jquery";
import {Languages} from "./Languages";

export type CurrencyType = 'PLN';
export const Currency = $("#meta_currency").attr("content") as CurrencyType;

export function formatCurrency(value: number): CurrencyType {
    let price = value.toFixed(2).toString();
    let parts = price.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    let formattedPrice = parts.join(",");

    return formattedPrice + " " + Currency as CurrencyType;
}

export function showPriceWithCurrentCurrency(
    price: number,
    spacesAfterComma: number = 2, 
    separator: 'comma' | 'dot' = 'comma'
): string {
    // Yeah, for some reason only french returns a space between thousands and hundreds
    let formattedPrice = price.toLocaleString('fr-FR', {minimumFractionDigits: spacesAfterComma});
    let formattedPriceWithProperSeparator: string;

    if (separator === 'comma') formattedPriceWithProperSeparator = formattedPrice.replace('.', ',');
    if (separator === 'dot') formattedPriceWithProperSeparator = formattedPrice.replace(',', '.');


    return `${formattedPriceWithProperSeparator} ${Currency}`;

}import * as $ from "jquery";
import {Languages} from "./Languages";

export type CurrencyType = 'PLN';
export const Currency = $("#meta_currency").attr("content") as CurrencyType;

export function formatCurrency(value: number): CurrencyType {
    let price = value.toFixed(2).toString();
    let parts = price.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    let formattedPrice = parts.join(",");

    return formattedPrice + " " + Currency as CurrencyType;
}

export function showPriceWithCurrentCurrency(
    price: number,
    spacesAfterComma: number = 2, 
    separator: 'comma' | 'dot' = 'comma'
): string {
    // Yeah, for some reason only french returns a space between thousands and hundreds
    let formattedPrice = price.toLocaleString('fr-FR', {minimumFractionDigits: spacesAfterComma});
    let formattedPriceWithProperSeparator: string;

    if (separator === 'comma') formattedPriceWithProperSeparator = formattedPrice.replace('.', ',');
    if (separator === 'dot') formattedPriceWithProperSeparator = formattedPrice.replace(',', '.');


    return `${formattedPriceWithProperSeparator} ${Currency}`;

}